module.exports = __webpack_public_path__ + "media/images/logo_axa-6c517a36.png";